import React from 'react';

interface PerinatalData {
  gestational_age_weeks: number | null;
  delivery_type: string;
  birth_weight_g: number | null;
  birth_height_cm: number | null;
  birth_head_cm: number | null;
  apgar_1min: number | null;
  apgar_5min: number | null;
  perinatal_complications: string;
}

interface Props {
  perinatal: PerinatalData;
  setPediatricField: (section: string, field: string, value: any) => void;
}

const PerinatalHistory: React.FC<Props> = ({ perinatal, setPediatricField }) => {
  const set = (field: string, value: any) => setPediatricField('perinatal', field, value);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">Antecedentes Perinatales</h5>
        <div className="row mt-3">
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Edad Gestacional (semanas)</label>
              <input
                type="number"
                className="form-control"
                min={24}
                max={42}
                value={perinatal.gestational_age_weeks ?? ''}
                onChange={(e) => set('gestational_age_weeks', e.target.value ? Number(e.target.value) : null)}
                placeholder="24-42"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Tipo de Parto</label>
              <select
                className="form-control"
                value={perinatal.delivery_type}
                onChange={(e) => set('delivery_type', e.target.value)}
              >
                <option value="">Seleccionar...</option>
                <option value="Vaginal">Vaginal</option>
                <option value="Cesárea">Cesárea</option>
                <option value="Fórceps">Fórceps</option>
              </select>
            </div>
          </div>
          <div className="col-md-2">
            <div className="mb-3">
              <label className="form-label">Peso al Nacer (g)</label>
              <input
                type="number"
                className="form-control"
                min={0}
                value={perinatal.birth_weight_g ?? ''}
                onChange={(e) => set('birth_weight_g', e.target.value ? Number(e.target.value) : null)}
                placeholder="gramos"
              />
            </div>
          </div>
          <div className="col-md-2">
            <div className="mb-3">
              <label className="form-label">Talla al Nacer (cm)</label>
              <input
                type="number"
                step="0.1"
                className="form-control"
                min={0}
                value={perinatal.birth_height_cm ?? ''}
                onChange={(e) => set('birth_height_cm', e.target.value ? Number(e.target.value) : null)}
                placeholder="cm"
              />
            </div>
          </div>
          <div className="col-md-2">
            <div className="mb-3">
              <label className="form-label">PC al Nacer (cm)</label>
              <input
                type="number"
                step="0.1"
                className="form-control"
                min={0}
                value={perinatal.birth_head_cm ?? ''}
                onChange={(e) => set('birth_head_cm', e.target.value ? Number(e.target.value) : null)}
                placeholder="cm"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="mb-3">
              <label className="form-label">Apgar 1 min</label>
              <input
                type="number"
                className="form-control"
                min={0}
                max={10}
                value={perinatal.apgar_1min ?? ''}
                onChange={(e) => set('apgar_1min', e.target.value ? Number(e.target.value) : null)}
              />
            </div>
          </div>
          <div className="col-md-2">
            <div className="mb-3">
              <label className="form-label">Apgar 5 min</label>
              <input
                type="number"
                className="form-control"
                min={0}
                max={10}
                value={perinatal.apgar_5min ?? ''}
                onChange={(e) => set('apgar_5min', e.target.value ? Number(e.target.value) : null)}
              />
            </div>
          </div>
          <div className="col-md-8">
            <div className="mb-3">
              <label className="form-label">Complicaciones Perinatales</label>
              <textarea
                className="form-control"
                rows={2}
                value={perinatal.perinatal_complications}
                onChange={(e) => set('perinatal_complications', e.target.value)}
                placeholder="Describa complicaciones del embarazo, parto o período neonatal..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerinatalHistory;
